import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../api/api.service';
import { STATISTICS_ENDPOINTS } from '../../api/endpoints/statistics.endpoints';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  private api = inject(ApiService);

  getOrderStats(params): Observable<any> {
    return this.api.get(STATISTICS_ENDPOINTS.V1.STATISTICS, { params: params });
  }
}
